import React, { useEffect, useState } from 'react';
import Main from '../Main.js';
import { Box } from '@mui/material';
import DataTable from '../Table/DataTable.js';
import { partnersDetailsColumns } from '../Table/TableColumns.js';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import { useDispatch, useSelector } from 'react-redux';
import { clearData, getAllPartners } from '../../../Redux/partnersRedux.js';
import AddPartners from './AddPartners.js';

function PartnersDetails() {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const user = JSON.parse(localStorage.getItem('user'));

  const { allPartners,newPartners,statusUpdate } = useSelector((state) => state.partnersRedux);

  useEffect(() => {
    const adminId = user.userId;
    dispatch(getAllPartners(adminId));
  }, [dispatch,newPartners,statusUpdate]);

  const handleButtonClick = () => {
    if (showForm) {
      dispatch(clearData());
    }
    setShowForm((prevShowForm) => !prevShowForm);
  };

  const rows = Array.isArray(allPartners)
    ? allPartners.map((partner, index) => {
        return {
          id: partner._id,
          sNo: index + 1,
          partnerName: partner.partnerName,
          images: partner.images,
          description: partner.description,
          location: partner.location,
          urlLink:partner.urlLink,
          isActive: partner.isActive === true ? 'Yes' : 'No',
        };
      })
    : [];
  return (
    <Main>
      <Box component='main' sx={{ flexGrow: 1, p: 3 }}>
        <div className='container border p-4'>
          <div className='row'>
            <div className='col-6'></div>
            <div className='col-6 text-end'>
              <button
                type='button'
                className='btn btn-success'
                onClick={handleButtonClick}
              >
                {showForm ? (
                  <BackupTableIcon style={{ marginRight: '5px' }} />
                ) : (
                  <AddCircleIcon style={{ marginRight: '5px' }} />
                )}
                {showForm ? 'Show Table' : 'Add Partners'}
              </button>
            </div>
          </div>
          {showForm ? (
            <AddPartners setShowForm={setShowForm} />
          ) : (
            <div className='row mt-3'>
              <div className='col-md-12'>
                <DataTable
                  setShowForm={setShowForm}
                  columns={partnersDetailsColumns}
                  rows={rows}
                  tableType='partners'
                />
              </div>
            </div>
          )}
        </div>
      </Box>
    </Main>
  );
}

export default PartnersDetails;
